/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMbDetailHist.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/mb-detail-hist";

export class AutogenModelMbDetailHist<RowType extends ModelRow> extends Endpoint<RowType, RowMbDetailHistFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMbDetailHist extends ModelRow<RowMbDetailHistFields> {
	constructor(values?: Partial<RowMbDetailHistFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMbDetailHistFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	charge_id: string;
	charge_method: string;
	charge_units: number;
	company_id: string;
	descr: string;
	id: string;
	is_taxable: string;
	misc_bill_id: string;
	rate: number;
	sequence: number;
}

